var EHDI = EHDI || Object.create(null);
var WAG = WAG || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

WAG.Weed = function()
{    
    EHDI.aka.Container.call(this);

    

    this.init = function (type, willGlow)
    {
        if(!this.sprite)
            this.sprite = new EHDI.aka.Sprite();

        this.isCut = false;
        this.worth=0;
        this.life=0;
        this.isTrap = false;
        this.wasClicked = false;

        if(type  == null)
        {
            var randomFactor = Math.random();
            if(randomFactor < 0.25)
            {
                this.changeVisual(3);
            }
            else if (randomFactor < 0.40)
            {
                this.changeVisual(2);
            }
            else
            {
                this.changeVisual(1);
            }
        }
        else
            this.changeVisual(type);

        if(willGlow)
            {
                if(!this.glow)
                    this.glow = new EHDI.components.GlowEffect(100);

                this.glow.y = -25;
                this.addChild(this.glow);
                this.glow.appear();

            }

        this.addChild(this.sprite);
        this.isCut = false;

        this.addInteraction();
    }


    this.changeVisual = function(type)
    {
        switch(type)
        {
            case 1:
                this.sprite.texture =EHDI.Assets.images['weed'];
                this.worth = 10;
                this.life = 1;
                this.hitArea = new PIXI.Rectangle(this.sprite.width * -0.5, this.sprite.height * -2, this.sprite.width *2, this.sprite.height * 2);
                break;            
            case 2:
                this.sprite.texture = EHDI.Assets.images['weed2'];
                this.worth = 30;
                this.life =2;
                break;
            default:
                this.sprite.texture = EHDI.Assets.images['clover'];
                this.worth = 0;
                this.life =1;
                this.isTrap = true;
                break;
        }
        this.sprite.y = this.sprite.height * -1;
        this.sprite.x = this.sprite.width *-0.5;
    }

    this.cut = function()
    {
        if(this.wasClicked)
            return;
        
        this.life--;
        this.wasClicked = true;

        if(this.isTrap)
            {
                
                this.removeGlow();
                EHDI.scene.GameScene.game.gameOver();
                return;
            }
        else
            {
                
                EHDI.GAME.soundManager.playSFX("plant_select");

                EHDI.scene.GameScene.scoreHolder.addScore(this.worth);
                
                EHDI.scene.GameScene.game.scoreEffects.popScore(this.x, this.y, this.worth);


                if(this.life <= 0)
                {
                    this.dispose();
                    this.isCut = true;
                    this.removeGlow();
                }
                else
                {                
                    this.changeVisual(this.life);
                    
                    this.armature = EHDI.DBoneFactory.createArmature("fx_cut_armature");
                    this.animationSprite = this.armature.getDisplay();
                    this.animList = this.armature.animation.animationList;
                    this.armature.animation.gotoAndPlay(this.animList[0], -1, -1, 1);
                    this.addChild(this.animationSprite);
                }
            }
    }

    this.removeGlow = function()
    {        
        if(this.glow)
            {
                this.glow.disappear();
                this.removeChild(this.glow);
            }
    }

    this.dispose = function()
    {
        this.removeChildren();
        this.removeInteraction();
    }

    this.update = function(delta)
    {
        this.wasClicked = false;

        if(this.glow)
            {
                this.glow.update(delta);
            }

        return this.isCut;
    }



    this.addInteraction = function()
    {
        
        if(EHDI.BrowserInfo.isMobileDevice)
            this.on('touchstart', this.cut);
        else
            this.on('mousedown', this.cut);
        this.interactive = true;

    }

    this.removeInteraction = function()
    {
        if(EHDI.BrowserInfo.isMobileDevice)
            this.off('touchstart', this.cut);
        else
            this.off('mousedown', this.cut);
        this.interactive = false;

    }

 
}
WAG.Weed.prototype = Object.create(EHDI.aka.Container.prototype);


POOLS.weedPool = new Pool(WAG.Weed, 18); 